import React from 'react';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { capitlalizeWordWithHyphen } from '@repo/utils';

export type MemberProfileMemberInfoPanelProps = {
  memberId: string;
  memberFirstName: string;
  memberLastName: string;
  memberDateOfBirth: string;
  memberZipCode: string;
  memberLineOfBusiness: string;
};

export function MemberProfileMemberInfoPanel({
  memberId,
  memberFirstName,
  memberLastName,
  memberDateOfBirth,
  memberZipCode,
  memberLineOfBusiness,
}: MemberProfileMemberInfoPanelProps): React.JSX.Element {
  return (
    <React.Fragment>
      <Heading serif>
        {memberFirstName && memberLastName
          ? `${capitlalizeWordWithHyphen(memberFirstName) ?? '--'} ${capitlalizeWordWithHyphen(memberLastName) ?? '--'}`
          : '-- --'}
      </Heading>

      <br></br>

      {/* FIXME - Text sizes */}
      <div style={{ display: 'flex', justifyItems: 'center' }}>
        <Text
          fontSize="lg"
          // FIXME
          style={{
            color: '#7D7F81',
          }}
        >
          {`ID: ${memberId ?? '--'}`}
        </Text>
        <Text
          fontSize="lg"
          // FIXME
          style={{
            padding: '0px 15px 0px 15px',
            color: '#003C71',
          }}
        >
          |
        </Text>
        <Text
          fontSize="lg"
          // FIXME
          style={{
            color: '#7D7F81',
          }}
        >
          {`Date of birth: ${memberDateOfBirth ?? '--'}`}
        </Text>

        <Text
          fontSize="lg"
          // FIXME
          style={{
            padding: '0px 15px 0px 15px',
            color: '#003C71',
          }}
        >
          |
        </Text>
        <Text
          fontSize="lg"
          // FIXME
          style={{
            color: '#7D7F81',
          }}
        >
          {`Zip code: ${memberZipCode ?? '--'}`}
        </Text>
      </div>

      <Text
        fontSize="lg"
        // FIXME type error
        style={{
          color: '#7D7F81',
        }}
      >
        {`Line of business: ${memberLineOfBusiness ?? '--'}`}
      </Text>
    </React.Fragment>
  );
}
